import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ROUTES } from './core/data/routes';
import ProtectedRoute from './core/components/ProtectedRoute';
import AppLayout from './features/layout/AppLayout';

import SplashScreen from './features/auth/pages/SplashScreen';
import LoginPage from './features/auth/pages/LoginPage';
import RegisterPage from './features/auth/pages/RegisterPage';
import OtpPage from './features/auth/pages/OtpPage';
import PreferencePage from './features/auth/pages/PreferencePage';
import IndexPage from './features/homepage/pages/IndexPage';
import DocSummaryPage from './features/homepage/pages/DocSummaryPage';
import { DeleteAccountPage, DeletedAccountPage } from './features/homepage/pages/AccountDeletionPages';
import UpcomingDetailsPage from './features/appointments/pages/UpcomingDetailsPage';
import BookingsPage from './features/appointments/pages/BookingsPage';
import BuySessionPage from './features/sessions/pages/BuySessionPage';
import ConferencePage from './features/sessions/pages/ConferencePage';
import AchievementPage from './features/sessions/pages/AchievementPage';
import { PaymentHistory2Page } from './features/payment/pages/PaymentHistoryPages';
import SettingsPage from './features/settings/pages/SettingsPage';
import AssessmentDetailsPage from './features/assessments/pages/AssessmentDetailsPage';
import PaymentDetailsPage from './features/payment/pages/PaymentDetailsPage';

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3500,
          style: {
            fontFamily: 'var(--font-family)',
            fontSize: '14px',
            borderRadius: '10px',
            background: 'var(--color-surface)',
            color: 'var(--color-on-surface)',
            boxShadow: 'var(--shadow-md)',
            border: '1px solid var(--color-outline-variant)',
          },
          success: { iconTheme: { primary: '#6BBA6B', secondary: 'white' } },
          error:   { iconTheme: { primary: '#E27C7C', secondary: 'white' } },
        }}
      />
      <Routes>
        {/* ── Public routes (no sidebar) ── */}
        <Route path={ROUTES.SPLASH}          element={<SplashScreen />} />
        <Route path={ROUTES.LOGIN}           element={<LoginPage />} />
        <Route path={ROUTES.REGISTER}        element={<RegisterPage />} />
        <Route path={ROUTES.OTP}             element={<OtpPage />} />
        <Route path={ROUTES.DELETED_ACCOUNT} element={<DeletedAccountPage />} />

        {/* ── Auth-only, no sidebar (preference setup flow) ── */}
        <Route path={ROUTES.PREFERENCE}      element={<ProtectedRoute><PreferencePage /></ProtectedRoute>} />
        <Route path={ROUTES.EDIT_PREFERENCE} element={<ProtectedRoute><PreferencePage /></ProtectedRoute>} />

        {/* ── Protected routes — sidebar persists across all ── */}
        <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
          <Route path={ROUTES.INDEX}              element={<IndexPage />} />
          <Route path={ROUTES.HOMEPAGE}           element={<IndexPage />} />
          <Route path={ROUTES.DOC_SUMMARY}        element={<DocSummaryPage />} />
          <Route path={ROUTES.UPCOMING_DETAILS}   element={<UpcomingDetailsPage />} />
          <Route path={ROUTES.BOOKINGS}           element={<BookingsPage />} />
          <Route path={ROUTES.SESSION}            element={<BuySessionPage />} />
          <Route path={ROUTES.CONFERENCE}         element={<ConferencePage />} />
          <Route path={ROUTES.ACHIEVEMENT}        element={<AchievementPage />} />
          {/* <Route path={ROUTES.PAYMENT_HISTORY}    element={<PaymentHistoryPage />} /> */}
          <Route path={ROUTES.PAYMENT_HISTORY2} element={<PaymentHistory2Page />} />
          <Route path="/payment-details" element={<PaymentDetailsPage />}
/>
          <Route path={ROUTES.SETTINGS}           element={<SettingsPage />} />
          <Route path={ROUTES.DELETE_ACCOUNT}     element={<DeleteAccountPage />} />
          <Route path={ROUTES.ASSESSMENT_DETAILS} element={<AssessmentDetailsPage />} />
        </Route>

        <Route path="*" element={<Navigate to={ROUTES.SPLASH} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;